import TokenTransactionsList from '../../components/VotingTokenTransactionsList';
import { __ } from '../../utils';
import SectionFooter from './SectionFooter';
import { Stack, Typography } from '@presov.sk/presov-ui-react';
import React from 'react';

/**
 * Použitie žetónov - história pohybov fondu.
 *
 * Stav fondu (veľké číslo a pásik) tu **nie je**: kreslí ho ľavý pás profilu
 * a rovnaké číslo stojí ako tichý údaj vedľa titulu, takže tretíkrát na tej
 * istej obrazovke by nepovedalo nič nové. Sekcia je odteraz len ten zoznam,
 * kvôli ktorému sa do nej chodí.
 */
const VotesTokens: React.FC = () => (
  <Stack gap={1.5} height={'100%'}>
    <Typography
      variant='body2'
      color='text.secondary'
      sx={{ flexShrink: 0, maxWidth: '60ch' }}
    >
      {__(
        'Jeden žetón = jedno hlasovanie v podnete. Nepoužité žetóny expirujú po 30 dňoch.',
      )}
    </Typography>

    <Stack sx={{ position: 'relative', flex: 1, minHeight: 0 }}>
      <TokenTransactionsList />
    </Stack>

    <SectionFooter
      hint={__('Žetón sa vráti do fondu, keď hlas odvoláte.')}
      action={{ label: __('Prejsť na hlasovania'), href: '/hlasovania' }}
    />
  </Stack>
);

export default VotesTokens;
